module.exports = __webpack_public_path__ + "static/media/brillumex-2.feed5ab8.jpg";